import { useFormikContext } from "formik";
import React, { FC } from "react";
import Togglebox from "../../components/togglebox/togglebox";
import { TranslationKeys } from "../../contexts/TranslationKeys";
import { useLocale } from "../../contexts/localeContext";
import Label from "../label/label";
import SettingSelectField from "@/components/settingFields/SettingSelectField.tsx";
import {AUTH_TYPE} from "@/constants/account-constants.ts";
import {useDialog} from "@/components/dialog/DialogContext.tsx";

interface AccountProps {
    currentItem: any,
    updateRequirementForCard:(removeRequire:boolean) => void
    isLicensed: boolean
}

const AuthAccountCard: FC<AccountProps> = ({updateRequirementForCard, isLicensed}) => {
    const {errors, values, setFieldValue} = useFormikContext<any>();
    const {translate} = useLocale();
    const dialog = useDialog();

    const errorHandler = (accessor) => {
        const error = accessor.split('.').reduce((previous, current) => {
                return previous?.[current]
            }
            , errors as any);
        if (error) {
            return <span className='text-red-600 text-xs'>{error}</span>
        } else {
            return null;
        }
    };

    const onEnabled = () => {
        const newEnabledState = !values.enabled;
        if (newEnabledState && !isLicensed) {
            dialog.pushError({ title: translate.byKey(TranslationKeys.unlicensed), message: translate.byKey(TranslationKeys.unlicensedFeature) });
            setFieldValue("enabled", false);
            return;
        }
        setFieldValue("enabled", newEnabledState);
    }

    const onAccountTypeChanged = (value) => {
        updateRequirementForCard(value && Number(value) !== AUTH_TYPE.GOOGLE)
    }

    const getTypeOptions = () => {
        return [
            // {label: AUTH_NAMES.GENERIC, value: "1"} // Generic option more for testing if needed,
            {label: translate.byKey(TranslationKeys.microsoftEntra), value: "3"},
            {label: translate.byKey(TranslationKeys.googleSignIn), value: "2"}
            // {label: AUTH_NAMES.GOOGLE, value: "2"},
            // {label: AUTH_NAMES.ENTRA, value: "3"}
        ];
    }

    return (
        <div className="w-full h-1/4 p-2 inline-flex justify-start items-top bg-white">
            <div className="py-4 px-8 mb-1">
                <div className="flex flex-row justify-between items-end" id="clientTypeLabel">
                    <Label htmlFor="details.clientType.value" required
                           className="text-xs text-gray-600 mt-1">{translate.byKey(TranslationKeys.type)}:</Label>
                    {errorHandler("details.clientType.value")}
                </div>
                <SettingSelectField
                    disabled={false}
                    accessor="details.clientType.value"
                    options={getTypeOptions()}
                    onSelect={(value) => {
                        setFieldValue("details.clientType.value", value?.value)
                        onAccountTypeChanged(value?.value);
                    }}
                    className='w-56' />
            </div>
            <div className="py-4 px-8 mb-1">
                <div className="flex flex-row justify-between" id="enabled">
                    <Label htmlFor="enabled" className="text-xs text-gray-600 mt-1">
                        {translate.byKey(TranslationKeys.enabled)}:
                    </Label>
                </div>
                <Togglebox name="enabled" onChanged={onEnabled} label={""} />
            </div>
        </div>
    )
}

export default AuthAccountCard;
